import { useParams } from "react-router-dom";
import {
  OrderByType,
  useGenericAPI,
  useSingleGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import { BASE_URL_HARDWARES } from "../services/APIservice";
import { Hardware, HardwarePatch } from "../types/hardware.types";
import useQueryURL from "../../../common/hooks/useQueryURL";
import { useAuth } from "../../auth/hooks";
import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI";


/**
 *
 * @param param0
 * @returns
 */
export default function useHardware(config?: {
  pageSize?: number;
  orderBy?: OrderByType<Hardware>;
  apiKey?: string;
}) {
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const apiHardwares = new APIGenerator<Hardware, HardwarePatch, HardwarePatch>(
    BASE_URL_HARDWARES
  );

  const findHardwareByDevUID = (deviceID: string) => {
    return apiHardwares.getAll({
      filter: {
        hardware_device_id: `=${deviceID}`,
      },
    }).then((res) => {
 
        if (res.data?.[0]){
            return res.data[0];
        }else{
            return null;
        }
    }).catch((err) => {
        return null;
    });
  };

  const getHardwareById = (id: string) => {
    return apiHardwares.getSingle(id).then((res) => {
        if (res){
            return res;
        }else{
            return null;
        }
    }).catch((err) => {
        return null;
    })
  }



  const genericHook = useGenericAPI<Hardware, HardwarePatch, HardwarePatch>({
    baseURL: BASE_URL_HARDWARES,
    APIname: config?.apiKey || "hardwares",
    pageSize: config?.pageSize || 5,
    orderBy: config?.orderBy || "-hardware_created_at",
  
  });
  return {
    ...genericHook,
    findHardwareByDevUID,
    getHardwareById
  };
}

/**
 *
 * @param id
 * @returns
 */
export const useSingleHardware = (id?: string) => {
  const { hardwareId } = useParams();
  const { getQueryValue } = useQueryURL();

  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  return useSingleGenericAPI<Hardware, HardwarePatch>({
    baseURL: BASE_URL_HARDWARES,
    APIname: "hardwares",
    id: id || hardwareId || getQueryValue("hardware_id") || "",
  });
};
